import writing_hand from 'src/assets/writing_hand.png';
import add_button from 'src/assets/add_button.png';
import filled_dot from 'src/assets/filled_dot.png';
import reflection_blob from 'src/assets/reflection_blob.png';
import journal_blob from 'src/assets/journal_blob.png';
import assessment_blob from 'src/assets/assessment_blob.png';
import gray_edit from 'src/assets/gray_edit.png';
import gray_bin from 'src/assets/gray_bin.png';
import blank_journal_icon from 'src/assets/blank_journal_icon.png';

import dayjs from 'dayjs'
import { useContext, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { defaultBgImgId } from 'src/consumer/constants'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { dataForBlankJournal } from 'src/consumer/helpers/dailyPlayHelper'
import { mediaURL } from 'src/consumer/services'
import { ModalProvider } from 'styled-react-modal'
import {
  AssessmentCardButton,
  AssessmentDetailsContainer,
  AssessmentItemContainer,
  AssessmentTitle,
  BackText,
  BackTextContainer,
  BlankJournalTextContainer,
  BlankModalHeading,
  CentralImage,
  CentralText,
  ContainerTopRight,
  CornerBlob,
  FadingBackground,
  IndexJournalEntryContainer,
  JournalButton,
  JournalCategory,
  JournalDayContainer,
  JournalDetailsContainer,
  JournalEntryTime,
  JournalEntryTitle,
  JournalIndexEntryLine,
  JournalItemBackgroundImage,
  JournalItemBackgroundOverlay,
  JournalItemContainer,
  JournalTitle,
  LineAndItemContainer,
  ScreenBackground,
  ShowAnswerIndexContainer,
  StartJournalingButton,
  StyledConnectingLine,
  StyledGenericModal,
  StyledLine,
  StyledSeparatorJournal,
  StyledUnderline,
  UserJournalTextArea,
} from './JournalStyles'

export const StartJournalingScreen = (props) => {
  const { setParentModalState } = props

  return (
    <ScreenBackground>
      <BlankModalHeading>{props?.heading}</BlankModalHeading>

      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <CentralImage src={writing_hand}className="img-fluid mb-3" />
        <CentralText main>{props?.maintext}</CentralText>
        <CentralText>{props?.subtext}</CentralText>
        <StartJournalingButton onClick={() => setParentModalState('browse_journals')}  className="mt-3">
          Start Journaling
          <img src={add_button} alt="Add Button"
            className="ml-2" />
        </StartJournalingButton>
      </div>
    </ScreenBackground>
  )
}

export const LoadingIconGroup = () => {
  return (
    <>
      <Spinner animation="grow" variant="danger" />
      <Spinner animation="grow" variant="warning" />
      <Spinner animation="grow" variant="info" />
    </>
  )
}

export const JournalInIndexComponent = (props) => {
  const {
    data,
    itemIndex,
    selectedJournalIndex,
    setSelectedJournalIndex,
    indexAnswerVisible,
    editJournalFunc,
    deleteJournalFunc,
  } = props

  return (
    <>
      {data?.type === 'dateItem' ? (
        <JournalDayContainer>
          <img src={filled_dot} />
          {data?.value}
        </JournalDayContainer>
      ) : (
        <LineAndItemContainer showResponse={indexAnswerVisible}>
          <StyledConnectingLine />

          <IndexJournalEntryContainer
            reflection={data?.journalType === 'reflection'}
            assessment={data?.journalType === 'assessment'}
            active={itemIndex === selectedJournalIndex}
            onClick={() => setSelectedJournalIndex(itemIndex)}
            showResponse={indexAnswerVisible}
          >
            <JournalEntryTime positioned assessment={data?.journalType === 'assessment'}>
              {moment
                .utc(data?.createdTime)
                .utcOffset(dayjs().utcOffset())
                .format('h:mm a, D MMM')}
            </JournalEntryTime>

            {data?.journalType === 'reflection' && !indexAnswerVisible && (
              <CornerBlob src={reflection_blob} />
            )}
            {data?.journalType === 'regular' && !indexAnswerVisible && (
              <CornerBlob src={journal_blob} />
            )}
            {data?.journalType === 'assessment' && !indexAnswerVisible && (
              <CornerBlob src={assessment_blob} />
            )}

            <div className="flex flex-col">
              <JournalEntryTitle assessment={data?.journalType === 'assessment'}>
                {data?.journalType === 'reflection' && data?.journalQusAns?.[0]?.question}
                {data?.journalType === 'regular' && data?.journal?.title}
                {data?.journalType === 'assessment' && data?.assessment?.title}
              </JournalEntryTitle>
              {!indexAnswerVisible && <JournalIndexEntryLine />}
              {!indexAnswerVisible && <JournalIndexEntryLine />}
              {!indexAnswerVisible && <JournalIndexEntryLine />}
            </div>

            <ShowAnswerIndexContainer>
              {data?.journalType === 'reflection' && indexAnswerVisible && (
                <UserJournalTextArea light>{data?.journalQusAns?.[0]?.answere}</UserJournalTextArea>
              )}

              {data?.journalType === 'regular' && indexAnswerVisible && (
                <>
                  {data?.journalQusAns?.map((item, index) => {
                    return (
                      <div key={index}>
                        <div>
                          <b>{item?.question}</b>
                        </div>
                        <UserJournalTextArea light>{item?.answere}</UserJournalTextArea>
                      </div>
                    )
                  })}
                </>
              )}
            </ShowAnswerIndexContainer>

            {itemIndex === selectedJournalIndex && indexAnswerVisible && (
              <ContainerTopRight onSmallBox>
                <JournalButton
                  small
                  src={gray_edit}
                  onClick={editJournalFunc}
                />
                <JournalButton
                  small
                  src={gray_bin}
                  onClick={deleteJournalFunc}
                />
              </ContainerTopRight>
            )}
          </IndexJournalEntryContainer>
        </LineAndItemContainer>
      )}
    </>
  )
}

export const NewJournalItem = (props) => {
  const { journalData, setJournalData } = useContext(JournalContext)
  const { data, category, setParentModalState, setNewEntryData } = props
  let imgId
  let imgUrl

  if (data?.verticalImage) {
    imgId = data?.verticalImage
  } else if (data?.coverImage) {
    imgId = data?.coverImage
  } else if (data?.coverIcon) {
    imgId = data?.coverIcon
  } else {
    imgId = defaultBgImgId
  }
  imgUrl = `${mediaURL}${imgId}`

  return (
    <>
      {data?.type === 'blank' ? (
        <JournalItemContainer className="flex justify-center align-items-center">
          <BlankJournalIconAndText
            text="Blank Journal"
            setParentModalState={setParentModalState}
            setNewEntryData={setNewEntryData}
          />
        </JournalItemContainer>
      ) : (
        <JournalItemContainer
          onClick={() => {
            setParentModalState('new_journal')
            setNewEntryData(data)
            setJournalData((prev) => {
              return { ...prev, pageState: 'new_journal', subscription: data?.subscription?.id }
            })
          }}
        >
          <JournalItemBackgroundImage src={imgUrl} />
          <JournalDetailsContainer hiddenBelow>
            <JournalCategory>{category?.singleTitle || category?.name}</JournalCategory>

            <StyledSeparatorJournal />

            <JournalTitle>{data?.title}</JournalTitle>

            <StyledLine />
            <StyledLine />
            <StyledLine />
          </JournalDetailsContainer>
        </JournalItemContainer>
      )}
    </>
  )
}

export const UnderlinedText = (props) => {
  const { setParentModalState } = props

  return (
    <BackTextContainer onClick={() => setParentModalState('user_journals')}>
      <BackText>{props?.backText}</BackText>
      <StyledUnderline />
    </BackTextContainer>
  )
}

export const BlankJournalIconAndText = (props) => {
  const { setParentModalState, setNewEntryData } = props
  const { journalData, setJournalData } = useContext(JournalContext)

  return (
    <div
      onClick={() => {
        setParentModalState('new_journal')
        setNewEntryData(dataForBlankJournal)
        setJournalData((prev) => {
          return {
            ...prev,
            pageState: 'new_journal',
            subscription: dataForBlankJournal?.subscription?.id,
          }
        })
      }}
    >
      <img src={blank_journal_icon} />
      <BlankJournalTextContainer>
        {props?.text?.split(' ')?.map((item, index) => {
          return <div key={index}>{item}</div>
        })}
      </BlankJournalTextContainer>
    </div>
  )
}

export const GenericModal = (props) => {
  const { isOpen, toggleFunc, onYes } = props
  const [opacity, setOpacity] = useState(0)

  function toggleModal(e) {
    setOpacity(0)
    toggleFunc()
  }

  function afterOpen() {
    setTimeout(() => {
      setOpacity(1)
    }, 100)
  }

  function beforeClose() {
    return new Promise((resolve) => {
      setOpacity(0)
      setTimeout(resolve, 300)
    })
  }

  return (
    <ModalProvider backgroundComponent={FadingBackground}>
      <StyledGenericModal
        isOpen={isOpen}
        afterOpen={afterOpen}
        beforeClose={beforeClose}
        onBackgroundClick={toggleModal}
        onEscapeKeydown={toggleModal}
        opacity={opacity}
        backgroundProps={{ opacity }}
      >
        <h2>{props?.warning}</h2>
        <p>{props?.warningDesc}</p>
        <div>
          <button id="yes-btn" onClick={onYes}>
            {props?.yes}
          </button>
          <button id="no-btn" onClick={toggleModal}>
            {props?.no}
          </button>
        </div>
      </StyledGenericModal>
    </ModalProvider>
  )
}

export const NewAssessmentItem = (props) => {
  const { data, category } = props
  const navigate = useNavigate()
  let imgUrl = data?.coverIcon ? `${mediaURL}${data?.coverIcon}` : `${mediaURL}${defaultBgImgId}`

  return (
    <AssessmentItemContainer
      onClick={() => {
        navigate(`/assessment/${data?.slug}`)
      }}
    >
      <JournalItemBackgroundImage src={imgUrl} />
      <JournalItemBackgroundOverlay />
      <AssessmentDetailsContainer>
        <AssessmentTitle>{data?.title}</AssessmentTitle>
        <AssessmentCardButton>Take Test</AssessmentCardButton>
      </AssessmentDetailsContainer>
    </AssessmentItemContainer>
  )
}
